import { render, staticRenderFns } from "./discussPage.vue?vue&type=template&id=1d705bde&scoped=true"
import script from "./discussPage.vue?vue&type=script&lang=js"
export * from "./discussPage.vue?vue&type=script&lang=js"
import style0 from "./discussPage.vue?vue&type=style&index=0&id=1d705bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d705bde",
  null
  
)

export default component.exports